import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GroupType} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class GroupTypeService {
    url = '/api/v1/admin/group-types';

    constructor(public http: HttpClient) {
    }

    addGroupType(groupType: any): any {
        return this.http.post<GroupType>(this.url, groupType);
    }

    updateGroupType(id: number, groupType: GroupType): any {
        return this.http.put(`${this.url}/${id}`, groupType);
    }

    getGroupTypes(): any {
        return this.http.get(this.url);
    }

    removeGroupType(id: number): any {
        return this.http.delete(`${this.url}/${id}`);
    }
}
